import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { postContextFeedbackApiUrlSelector } from '../selectors/getContextApiSelectors';
import { makePost } from '../utils/makeFetchUtil';
import { MODULE_NAME } from '../constants/modules';
import { getPayloadForContextFeedbackLoop } from '../utils/abandonCartUtils';

export const postContextFeedbackThunk = ({
  abandonCartData,
}) => async (dispatch, getState) => {
  const state = getState();
  const postContextFeedbackUrl = postContextFeedbackApiUrlSelector(state);
  const payload = getPayloadForContextFeedbackLoop({ abandonCartData });

  try {
    const { response, correlationId } = await makePost({
      url: postContextFeedbackUrl,
      body: payload,
    });

    if (response?.status !== 200 && response?.status !== 201) {
      await dispatch(
        addErrorToReport({
          collectionMethod: 'Fetch Error',
          moduleID: MODULE_NAME,
          component: 'postContextFeedbackThunk',
          fetch: {
            url: postContextFeedbackUrl,
            status: response?.status,
            correlationId,
          },
          note: 'Error while posting context feedback - Response status was not 200 or 201',
        })
      );
    }
  } catch (error) {
    await dispatch(addErrorToReport(
      error,
      {
        collectionMethod: 'Fetch Error',
        moduleID: MODULE_NAME,
        component: 'postContextFeedbackThunk',
        note: 'Fetch Failure Error',
      }
    ));
  }
};
